import React, { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import Translator from '../helpers/Translator';
import AppModal from './AppModal';

export default function InfoModal(props) {
  const {
    children,
    selector,
    size = 'md',
    className = '',
    title = '',
    fullscreen = false,
  } = props;
  const [show, setShow] = useState(false);

  return (
    <>
      <AppModal
        show={show}
        isConfirmBtn
        isCancelBtn={false}
        title={title}
        size={size}
        confirmBtnText={ReactDOMServer.renderToString(<Translator file="general" name="understood" />)}
        onClose={() => setShow(false)}
        onConfirm={() => setShow(false)}
        fullscreen={fullscreen}
      >
        {children}
      </AppModal>
      <div onClick={() => setShow(true)}>
        {selector}
      </div>
    </>
  );
}
